import {
    del,
    get,
} from "@itslearning/atlas/network/fetch";

const headers = (antiForgeryHeaderName, antiForgeryHeaderValue) => ({
    "headers": {
        [antiForgeryHeaderName]: antiForgeryHeaderValue,
    }
});

/**
 * Dismisses course copy error for specific course.
 * @param {number} courseId
 * @param {string} antiForgeryHeaderName
 * @param {string} antiForgeryHeaderValue
 * @returns {Promise} The response returned by the API.
 */
export const dismissCourseCopyErrors = (courseId, antiForgeryHeaderName, antiForgeryHeaderValue) =>
    del(
        `/restapi/courses/${courseId}/copy/errors/v1`,
        {},
        headers(antiForgeryHeaderName, antiForgeryHeaderValue)
    );

/**
 * @typedef {object} FeedbackBannerModel
 * @property {string} message
 * @property {string} feedbackType
 * @property {string} closeActionType
 * @property {string} closeButtonName
 * @property {boolean} isCloseable
 * @property {boolean} isVisible
 * @property {object} data
 */

/**
 * @typedef {object} GetCourseCopyStatusResponseModel
 * @property {string} copyStatus
 * @property {FeedbackBannerModel} feedbackBanner
 */

/**
 * Gets copy status for specific course by its ID.
 * @param {number} courseId
 * @returns {Promise<GetCourseCopyStatusResponseModel>} The response returned by the API.
 */
export const checkCopyCourseStatus = (courseId) =>
    get(`/restapi/courses/${courseId}/copy/status/v1?use2025Design=true`);
